import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})

export class UserService {

    status: any = 0;
    category = 2;
    token: any = '';
    id: any = '0';
    type = 'Visitor';
    slug: any = '';
    fname = '';
    lname = '';
    bname = '';
    name = '';
    dp = '';
    cover = '';
    genre = [];
    country = '';
    state = '';
    city = '';
    artistType = [];
    mobile = '';
    email = '';
    isEmailVerified: Boolean = false;
    isMobVerified: Boolean = false;
    songsCount: any = 0;
    videosCount: any = 0;
    isPwdSet: Boolean = false;
    iswhatsapp_verify: Boolean = false;
    whatsapp_number:number;
    isFromIndia: Boolean = true;
    ip = '';

    authorize_for_tv = false;
    isProMember: number = 0;
    expdays: number = 0;
    bandStatus: boolean ;
    isLabel: boolean =false;
    constructor() {
        if (localStorage.getItem('category') != 'undefined' && localStorage.getItem('category') && localStorage.getItem('category') != null) {
            this.category = JSON.parse(localStorage.getItem('category'));
        }
        if (localStorage.getItem('token')) {
            this.token = JSON.parse(localStorage.getItem('token'));
        }
        if (localStorage.getItem('id')) {
            this.id = JSON.parse(localStorage.getItem('id'));
        }
        if (localStorage.getItem('type')) {
            this.type = JSON.parse(localStorage.getItem('type'));
        }
        if (localStorage.getItem('slug')) {
            this.slug = JSON.parse(localStorage.getItem('slug'));
        }
        if (localStorage.getItem('fname')) {
            this.fname = JSON.parse(localStorage.getItem('fname'));
        }
        if (localStorage.getItem('lname')) {
            this.lname = JSON.parse(localStorage.getItem('lname'));
        }
        if (localStorage.getItem('dp')) {
            this.dp = JSON.parse(localStorage.getItem('dp'));
        }
        if (localStorage.getItem('cover')) {
            this.cover = JSON.parse(localStorage.getItem('cover'));
        }
        if (localStorage.getItem('genre')) {
            this.genre = JSON.parse(localStorage.getItem('genre'));
        }
        // if ( localStorage.getItem('country') ) {
        //     this.country = JSON.parse(localStorage.getItem('country'));
        // }
        // if ( localStorage.getItem('state') ) {
        //     this.state = JSON.parse(localStorage.getItem('state'));
        // }
        // if ( localStorage.getItem('city') ) {
        //     this.city = JSON.parse(localStorage.getItem('city'));
        // }
        if (localStorage.getItem('artistType')) {
            this.artistType = JSON.parse(localStorage.getItem('artistType'));
        }
        if (localStorage.getItem('mobile')) {
            this.mobile = JSON.parse(localStorage.getItem('mobile'));
        }
        if (localStorage.getItem('email')) {
            this.email = JSON.parse(localStorage.getItem('email'));
        }
        if (localStorage.getItem('isEmailVerified')) {
            this.isEmailVerified = JSON.parse(localStorage.getItem('isEmailVerified'));
        }
        if (localStorage.getItem('isMobVerified')) {
            this.isMobVerified = JSON.parse(localStorage.getItem('isMobVerified'));
        }
        if (localStorage.getItem('isPwdSet')) {
            this.isPwdSet = JSON.parse(localStorage.getItem('isPwdSet'));
        }
        if (localStorage.getItem('isProMember')) {
            this.isProMember = JSON.parse(localStorage.getItem('isProMember'));
        }
        if (localStorage.getItem('iswhatsapp_verify')) {
            this.iswhatsapp_verify = JSON.parse(localStorage.getItem('iswhatsapp_verify'));
        }
        if (localStorage.getItem('whatsapp_number')) {
            this.whatsapp_number = JSON.parse(localStorage.getItem('whatsapp_number'));
        }

        if (this.type == 'Band') {
            this.status = 2;
        } else if (this.type == 'Artist') {
            this.status = 1;
        } else if (this.type == 'Listener') {
            this.status = 3;
        }

        this.name = this.fname + ' ' + this.lname;
    }
}
